import Page from "components/common/Page"
import PageCard from "components/common/PageCard"
import nirvanaErrorLogo from '../../../resources/nirvanaError.png'
import $t from '../../../i18n'
import { useSelector } from 'react-redux'
import './HmoHistoryData.css'
const  HmoHistoryData = () => {
    const antidoteSupportEmail = useSelector(
        state => state.app.antidoteSupportEmail
      )

    return (
        <PageCard enableBack={true}>
        <Page
          className="hmo-history-data-page"
          title = {$t('pages.HmoHistoryData.title')}
        >
          { (
            <div className="error-message">
              {$t('pages.HmoHistoryData.subtitle')}
                <a className="link" href={`mailto:${antidoteSupportEmail}`}>
                    {antidoteSupportEmail}
                </a>
            <img
                src={nirvanaErrorLogo}
                alt="hmo-history-error"
                className="nirvana-error-image"
              />
            </div>
          )}
        </Page>
        </PageCard>
      )
}

export default HmoHistoryData


